import {ImYoutube} from 'react-icons/im';
import {FaTwitter} from 'react-icons/fa';
import {FaFacebookF} from 'react-icons/fa';
import {FiInstagram} from 'react-icons/fi';

export const social = [
    {icon:<ImYoutube />},
    {icon:<FaTwitter />},
    {icon:<FiInstagram/>},
    {icon:<FaFacebookF/>}
];
export const footerLinks = [
    {
        category:"Platform",
        links:[
            {
                link:"Why HostDesign",
                to:"/why-hostdesign"
            },
            {
                link:"Enterprise",
                to:"/enterprise"
            },
            {
                link:"Mobile Apps",
                to:"/mobile-apps"
            },
            {
                link:"Pricing",
                to:"/Pricing"
            },
            {
                link:"Developer-api",
                to:"/developer-api"
            },
        ]
    },
    {
        category:"Features",
        links:[
            {
                link:"Collaboration",
                to:"/collaboration"
            },
            {
                link:"wireframing",
                to:"/wireframing"
            },
            {
                link:"prototyping",
                to:"/prototyping"
            },
            {
                link:"Usability Testing",
                to:"/usability-testing"
            },
        ]
    },
    {
        category:"Support",
        links:[
            {
                link:"Help Center",
                to:"/help-center"
            },
            {
                link:"Terms of Service",
                to:"/terms"
            },
            {
                link:"Privacy",
                to:"/Privacy"
            },
            {
                link:"Status",
                to:"/status"
            },
            {
                link:"Security",
                to:"/security"
            },
            {
                link:"Resources",
                to:"/resources"
            },
        ]
    },
    {
        category:"Company",
        links:[
            {
                link:"Blog",
                to:"/blog"
            },
            {
                link:"About Us",
                to:"/about-us"
            },
            {
                link:"Jobs",
                to:"/jobs"
            },
            {
                link:"Contact Us",
                to:"/contact-us"
            },
            {
                link:"Customer Stories",
                to:"/customer-stories"
            },
            {
                link:"Labs",
                to:"/Labs"
            },
            {
                link:"Careers",
                to:"/careers"
            },

        ]
    },


]

